const getCartProductQuantity = (cartProductList) => cartProductList.reduce((acc, item) => acc + item.quantity, 0)

export default getCartProductQuantity
